import service from '@/api/newsletter/queueDate';
import {handleError} from '@/state/generators/helpers';

export const state = {
    calendarLoading: false,
    calendar: [],
    service: service('newsletters/queueDates')
}

export const getters = {
    loading: function (state) {
        return !!state.loading
    },
    calendar: function (state) {
        return state.calendar
    },
}

export const mutations = {
    'SET_CALENDAR_LOADING': function (state, boolean = true) {
        state.calendarLoading = boolean
    },

    'SET_CALENDAR': function (state, list) {
        state.calendar = list
    },
}

export const actions = {
    calendar: function ({commit, state}, filters) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_CALENDAR_LOADING', true);

        return state.service.calendar(filters).then(response => {
            commit('SET_CALENDAR', response.data);
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_CALENDAR_LOADING', false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },

    updateDate: function ({commit, state}, {id, data}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_CALENDAR_LOADING', true);

        return state.service.updateDate(id, data).then(response => {
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_CALENDAR_LOADING', false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },
}
